import React, { Component } from 'react';
import recurlyOptions from './recurlyOptions';
import Events from '../../common/events';
import { strings } from '../../../localization';
import LambdaUtil from '../../aws/lambda/lambdaUtil';

export default class EditPlanSection extends Component {

    constructor(props) {

        super(props);
        this.state = {
        };
    }

    componentDidMount() {

        //attach recurly pricing calculator for new subscription
        {
            var form = document.querySelector('#pricing');
            if (form) {
                window.recurly.configure(recurlyOptions);
                var pricing = window.recurly.Pricing();
                console.log(pricing);
                pricing.attach(form);
                pricing.on('error', (error) => {
                    console.log(error);
                });
                pricing.on('change', (e) => {

                    // console.log("OnPricingChange");

                    var newplan = this.planCodeInput ? this.planCodeInput.value : null;
                    var origplan = this.props.subscription ? this.props.subscription.planCode : null;
                    console.log(e);
                    pricing.attach(form);
                    this.props.saveRecurlyPricing(e, newplan); //must pass plancode as separate object, can't change recurly object or risk infinite recurly update loop bug
                    if (e && newplan !== origplan)
                    {
                        document.getElementById('submitBtn').disabled = false;
                        // document.getElementById('submitBtn').innerHTML = '<i class="material-icons">check</i>Select Plan';
                    }
                    else
                    {
                        // document.getElementById('submitBtn').innerHTML = 'Selected';
                    }
                });
            }
        }

        // Disable the submit button on first render
        document.getElementById('submitBtn').disabled = true;
    }

    onOptionClick = (e) => {

        // console.log("OnOptionClick");

        this.props.saveRecurlyPricing(null);
        document.getElementById('submitBtn').disabled = true;
    }

    submitServicePlan = (e) => {

        // console.log("Submit Service Plan");

        try {
            e.preventDefault();
            var planTitle = this.props.targetPlanCode;
            if (strings["plan_title_" + this.props.targetPlanCode]) planTitle = strings.formatString(strings["plan_title_" + this.props.targetPlanCode]);
            var loadingScreenMessage = "Subscribing to " + planTitle;
            var loadingScreenSubMessage = "This may take up to 10 minutes";
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: loadingScreenMessage, loadingPageSubMessage: loadingScreenSubMessage } }));
            if (this.props.subscription) {
                LambdaUtil.updateServicePlan(this.props.user.stage, this.props.targetPlanCode, this.props.subscription.subscriptionUuid, this.onSubscriptionSuccess, this.onSubscriptionFail);
            } else {
                LambdaUtil.subscribeServicePlan(this.props.user.stage, this.props.targetPlanCode, this.props.raven.ravenUuid, this.onSubscriptionSuccess, this.onSubscriptionFail);
            }
        } catch (e) {
            console.error(e);
            this.onSubscriptionFail();
        }
    }

    onSubscriptionSuccess = (data) => {

        var payload = JSON.parse(data.Payload);
        if (payload.status === 'ERROR') {
            if (payload.message.indexOf('Unknown') > -1) {
                console.error(payload);
                this.genericError();
            } else {
                console.error(payload);
                this.setState({
                    errorMessage: payload.message
                });
            }
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        } else {
            document.documentElement.classList.remove("no-scroll");
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: "Subscription Successful", style: 'success', 'override': true } }));
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
    }

    onSubscriptionFail = (err) => {

        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        this.genericError();
    }

    genericError() {

        this.setState({
            errorMessage: strings.formatString(strings.account_error_upate_sub)
        }, () => {
            this.props.refreshAccountDetails(); //just in case something changed
        })
    }

    render() {

        console.log(this.props, this.state);

        var title = <h2><i className="material-icons">data_usage</i> {strings.raven_subscription_edit} {this.props.raven.vehicle ? <span>- <span className="blue">{this.props.raven.vehicle.name}</span></span> : null}</h2>;
        if (!this.props.subscription) title = <h2><i className="material-icons">data_usage</i> {strings.raven_subscription_select_a_service_plan} {this.props.raven.vehicle ? <span>- <span className="blue">{this.props.raven.vehicle.name}</span></span> : null}</h2>

        var planOptions = this.props.availableServicePlans.map((planCode, i) => {
            planCode = planCode.planCode;
            var planTitle = planCode;
            if (strings["plan_title_" + planCode]) planTitle = strings.formatString(strings["plan_title_" + planCode]);
            return <option key={i} value={planCode}>{planTitle}</option>
        })

        return (
            <div className="col-12 content-group">
                {title}
                <form id="pricing" className="row">
                    <input type="hidden" value="1" data-recurly="plan_quantity" />
                    <input type="hidden" value="USD" data-recurly="currency" />
                    <input type="hidden" value="US" data-recurly="country" />

                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 col-sm-8">
                                <label htmlFor="servicePlan">{strings.raven_subscription_select_a_service_plan}</label>
                                {/*<Select id="data-plan" options={dataPlanOptions} value={0} name="data-plan" clearable={false} searchable={false} />*/}
                                <select ref={(planCodeInput) => { this.planCodeInput = planCodeInput }} id="servicePlan" data-recurly="plan" defaultValue={this.props.subscription ? this.props.subscription.planCode : "basic"} onChange={this.onOptionClick}>
                                    {planOptions}
                                </select>
                            </div>
                            <div className="col-12 col-sm-4">
                                <label htmlFor="couponCode">{strings.raven_subscription_coupon_code_label}</label>
                                <input id="couponCode" type="text" data-recurly="coupon" />
                            </div>

                            <div className="col-12">
                                {this.renderPlanDetails(
                                    this.planCodeInput ? this.planCodeInput.value : null,
                                    this.props.recurlyPricing ? this.props.recurlyPricing.base : null)
                                }

                                <p><a href="https://raven.is/pages/service-plans">{strings.raven_subscription_view_all_raven_service_plans}</a></p>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 action-btns text-right">
                        {/*this.props.subscription && this.props.subscription.state !== 'canceled' ? <button className="btn btn-outline-blue btn-left" onClick={this.props.onCancelPlanClick}><i className="material-icons">close</i>Cancel Service Plan</button> : null*/}
                        <button className="btn btn-outline-blue" onClick={this.props.closeEditPlanModal}><i className="material-icons">close</i>{strings.action_cancel}</button>
                        <button className="btn" id="submitBtn" onClick={this.submitServicePlan}><i class="material-icons">check</i>{strings.action_select_plan}</button>
                    </div>
                    <div className="col-12">
                        {this.props.duplicateTargetPlan ? <p className="red"><i className="material-icons">error_outline</i>{strings.raven_subscription_youre_already_subscribed_to_the_service_plan_you_selected}</p> : null}
                    </div>
                    <div className="col-12">
                        {this.state.errorMessage ? <p className="red"><i className="material-icons">error_outline</i>{this.state.errorMessage}</p> : null}
                    </div>
                </form>
            </div>
        )
    }

    renderPlanDetails(planCode) {

        var title = <h4>{planCode}</h4>;
        var featureList = null;
        switch (planCode) {
            case 'freetrial':
                title = <h4>{strings.raven_subscription_freetrial_features_title}</h4>
                featureList = [
                    <li><i className="material-icons blue">check_circle</i>{strings.raven_subscription_freetrial_feature_1}</li>,
                ];
                break;
            case 'basic':
                title = <h4>{strings.raven_subscription_basic_features_title}</h4>
                featureList = [
                    <li><i className="material-icons blue">videocam</i>{strings.raven_subscription_basic_feature_1}</li>,
                    <li><i className="material-icons blue">notifications</i>{strings.raven_subscription_basic_feature_2}</li>
                ];
                break;
            case 'streaming_plus':
                title = <h4>{strings.raven_subscription_streaming_plus_features_title}</h4>
                featureList = [
                    <li><i className="material-icons blue">videocam</i>{strings.raven_subscription_streaming_plus_feature_1}</li>,
                    <li><i className="material-icons blue">notifications</i>{strings.raven_subscription_streaming_plus_feature_2}</li>
                ];
                break;
            case 'nsp':
                title = <h4>{strings.raven_subscription_nsp_features_title}</h4>
                featureList = [
                    <li key={0}><i className="material-icons blue">videocam_off</i>{strings.raven_subscription_nsp_feature_1}</li>,
                    <li key={1}><i className="material-icons blue">notifications_off</i>{strings.raven_subscription_nsp_feature_2}</li>
                ]
                break;
        }
        return (
            <div className="plan-details">
                {title}
                <ul className="styled-list">
                    {featureList}
                    <li><i className="material-icons blue">attach_money</i>{this.props.recurlyPricing ? this.props.recurlyPricing.base.plan.unit : null} <span data-recurly="currency_code"></span> {strings.raven_subscription_monthly}</li>
                </ul>
            </div>
        );
    }
}
